export default __webpack_public_path__ + "static/media/arrowlight.defdc8c7.svg";